export const TimeObjToDate = (t) => {
  return new Date(t.seconds * 1000);
};
